<div class="page-container">
    <div class="page-header">
        <div class="header-content">
            <h1 class="page-title">Transport Management</h1>
            <p class="page-subtitle">Assign trucks to unassigned bookings</p>
        </div>
    </div>

    <!-- Loading Spinner -->
    <div *ngIf="isLoading" class="loading-overlay">
        <mat-spinner diameter="50" color="primary"></mat-spinner>
        <p class="loading-text">Loading bookings...</p>
    </div>

    <div class="card" [class.loading]="isLoading">
        <div class="card-header">
            <h2 class="card-title">Unassigned Bookings</h2>
        </div>

        <div class="filter-bar">
            <button
                class="filter-chip"
                [class.active]="selectedTruckTypeFilter === null"
                (click)="setTruckTypeFilter(null)">
                All
            </button>
            <button
                *ngFor="let type of sortedTruckTypeFilters"
                class="filter-chip"
                [class.active]="selectedTruckTypeFilter === type"
                (click)="setTruckTypeFilter(type)">
                {{ type }}
            </button>
        </div>

        <div class="table-container" *ngIf="filteredDatas.length > 0">
            <table class="data-table">
                <thead>
                    <tr>
                        <th>Booking Reference</th>
                        <th>Customer</th>
                        <th>Truck Type</th>
                        <th>Truck Assigned</th>
                        <th>Remaining Trucks</th>
                        <th>SLA Delivery</th>
                        <th class="th-actions">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of filteredDatas">
                        <td>
                            <span class="cell-text cell-text-ref">{{ data.ref }}</span>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.customer }}</span>
                        </td>
                        <td>
                            <div class="truck-badges">
                                <ng-container *ngFor="let truck of parseTruckTypes(data.truckType)">
                                    <div class="truck-badge">
                                        <mat-icon class="truck-icon">local_shipping</mat-icon>
                                        <span class="truck-type">{{ truck.type }}</span>
                                        <span class="truck-count">× {{ truck.count }}</span>
                                    </div>
                                </ng-container>
                            </div>
                        </td>
                        <td>
                            <div class="assigned-trucks-cell">
                                <ng-container *ngIf="data.assignedTrucks.length > 0; else noTrucks">
                                    <div class="assigned-trucks-trigger" (click)="$event.stopPropagation(); togglePopover(data, $event)">
                                        <mat-icon class="eye-icon">visibility</mat-icon>
                                        <span class="assigned-count">{{ data.assignedTrucks.length }}</span>
                                    </div>
                                </ng-container>
                                <ng-template #noTrucks>
                                    <span class="cell-text cell-text-secondary">—</span>
                                </ng-template>
                            </div>
                        </td>
                        <td>
                            <span class="remaining-badge" [class.remaining-zero]="data.remainingTrucksNeeded === 0">
                                {{ data.remainingTrucksNeeded }}
                            </span>
                        </td>
                        <td>
                            <span class="cell-text">{{ data.slaDelivery }}</span>
                        </td>
                        <td class="actions-cell">
                            <button class="btn-assign" (click)="openAssignDialog(data)">
                                <mat-icon>{{ data.remainingTrucksNeeded === 0 ? 'edit' : 'local_shipping' }}</mat-icon>
                                <span>{{ data.remainingTrucksNeeded === 0 ? 'Update Truck' : 'Assign Truck' }}</span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="empty-state" *ngIf="filteredDatas.length === 0">
            <mat-icon class="empty-icon">assignment_turned_in</mat-icon>
            <h3>No unassigned bookings</h3>
            <p>All bookings have been assigned to trucks</p>
        </div>

        <div class="card-footer" *ngIf="totalPages > 1">
            <div class="pagination-info">
                Showing <strong>{{ (currentPage - 1) * pageSize + 1 }}</strong> to
                <strong>{{ currentPage * pageSize > datas.length ? datas.length : currentPage * pageSize }}</strong>
                of <strong>{{ datas.length }}</strong> bookings
            </div>

            <div class="pagination">
                <button class="pagination-btn" [disabled]="currentPage === 1" (click)="getOrderList(currentPage - 1)">
                    <mat-icon>chevron_left</mat-icon>
                </button>

                <ng-container *ngFor="let page of pages">
                    <button
                        class="pagination-btn pagination-number"
                        [ngClass]="{ 'active': page === currentPage }"
                        (click)="getOrderList(page)">
                        {{ page }}
                    </button>
                </ng-container>

                <button class="pagination-btn" [disabled]="currentPage === totalPages" (click)="getOrderList(currentPage + 1)">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Fixed popover overlay — outside all cards/containers to avoid any transform/overflow clipping -->
<div class="truck-popover-overlay"
     *ngIf="activePopoverData"
     [style.top.px]="popoverY"
     [style.left.px]="popoverX"
     (click)="$event.stopPropagation()">
    <div class="popover-header">
        <span class="popover-title">Assigned Trucks</span>
    </div>
    <div class="popover-item" *ngFor="let truck of activePopoverData.assignedTrucks">
        <mat-icon class="popover-truck-icon">local_shipping</mat-icon>
        <span class="popover-truck-label">{{ truck.plateNumber }} ({{ truck.truckType }})</span>
        <button class="btn-unassign" (click)="confirmUnassignTruck(activePopoverData, truck)" title="Unassign truck">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>
